import React, { useRef, useEffect, useState } from "react";
import axios from "axios";
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, LineController } from "chart.js";


// Register necessary components for chart
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  LineController
);

const NavChart = ({ timePeriod, NavUrl, NavAPIKey, setReturnPercentage, email }) => {

  const areaChartRef = useRef(null);
  const areaChartInstance = useRef(null);

  const updateCharts = (selectedRange) => {
    if (!areaChartRef.current) {
      console.error("areaChartRef.current is null");
      return;
    }

    axios
      .get(`${NavUrl}/nav-chart/?range=` + selectedRange, {
        headers: {
          authorization: `${NavAPIKey}`,
        },
          params: { email }
      })
      .then((response) => {
        const data = response.data.data;
        const returnPercentage = response.data.returnPercentage; 

        // Pass returnPercentage to parent component
        if (setReturnPercentage) {
          setReturnPercentage(returnPercentage);
        }

        // Extract dates and NAV values
        const labels = data.map((item) => {
          const date = new Date(item.date);
          return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;
        });
        const navs = data.map((item) => parseFloat(item.nav));

        // Check if the chart instance already exists
        if (areaChartInstance.current) {
          // Update the chart's labels and data
          areaChartInstance.current.data.labels = labels;
          areaChartInstance.current.data.datasets[0].data = navs;

          // Update the chart to reflect the new data
          areaChartInstance.current.update();
        } else {
          // If the chart instance doesn't exist, create a new one
          const areaChartCtx = areaChartRef.current.getContext("2d");
          areaChartInstance.current = new ChartJS(areaChartCtx, {
            type: "line",
            data: {
              labels: labels,
              datasets: [
                {
                  label: "NAV",
                  data: navs,
                  borderColor: "#00acc1",
                  borderWidth: 2,
                  pointRadius: 0,
                },
              ],
            },
            options: {
              responsive: true,
              plugins: {
                tooltip: {
                  enabled: true,
                  mode: "index", // Tooltip will be shown when hovering anywhere along the x-axis
                  intersect: false, // Tooltip will display when hovering over any part of the line
                  callbacks: {
                    label: function (tooltipItem) {
                      const label = tooltipItem.dataset.label || "";
                      const value = tooltipItem.raw; // Get the data point value
                      return `${label}: ${value.toFixed(4)}`; // Format the tooltip content
                    },
                  },
                },
                legend: { display: false },
              },
            },
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
      if (!email) return;
    // Only update the chart if the ref is available
    if (areaChartRef.current) {
      updateCharts(timePeriod);
    }
  }, [timePeriod,email]);

  return (
    <div>
      <canvas ref={areaChartRef}></canvas>
    </div>
  );
};

export default NavChart;

